import iconLarge from '../../../public/img/templates/defult-large.jpg'
import iconSmall from '../../../public/img/templates/defult-small.jpg'
import apiService from '../../services/apiService'

export default {
  getRichmenuTemplate: async function ({ commit }) {
    var richMenu = {
      large: [
        {
          image: iconLarge,
          id: 0
        },
        {
          image: '/img/templates/template-01.png',
          id: 1,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1667,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 0,
                y: 843,
                width: 1667,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1667,
                y: 0,
                width: 833,
                height: 1686,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-02.png',
          id: 2,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1500,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1500,
                y: 0,
                width: 1000,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1500,
                y: 562,
                width: 1000,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1500,
                y: 1124,
                width: 1000,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-03.png',
          id: 3,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1666,
                height: 1124,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 0,
                y: 1124,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 833,
                y: 1124,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1666,
                y: 0,
                width: 834,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-04.png',
          id: 4,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1667,
                height: 1124,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1667,
                y: 0,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1667,
                y: 562,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 1124,
                width: 2500,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-05.png',
          id: 5,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 834,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 834,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1667,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 834,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1667,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-06.png',
          id: 6,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1666,
                y: 0,
                width: 834,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-07.png',
          id: 7,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1666,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1666,
                y: 0,
                width: 834,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 1180,
                width: 833,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 833,
                y: 1180,
                width: 833,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1666,
                y: 1180,
                width: 833,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-08.png',
          id: 8,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1666,
                y: 843,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-09.png',
          id: 9,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1666,
                y: 0,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 1666,
                y: 843,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-10.png',
          id: 10,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1666,
                y: 0,
                width: 834,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 1180,
                width: 833,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 833,
                y: 1180,
                width: 833,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 1666,
                y: 1180,
                width: 834,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-11.png',
          id: 11,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1500,
                height: 1180,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1500,
                y: 0,
                width: 1000,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 1180,
                width: 750,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 750,
                y: 1180,
                width: 750,
                height: 506,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-12.png',
          id: 12,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 843,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1250,
                y: 843,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 1875,
                y: 843,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-13.png',
          id: 13,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1666,
                y: 0,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 562,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 833,
                y: 562,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 1666,
                y: 562,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '7',
                x: 0,
                y: 1124,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '8',
                x: 833,
                y: 1124,
                width: 833,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '9',
                x: 1666,
                y: 1124,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-14.png',
          id: 14,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1666,
                y: 0,
                width: 834,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-15.png',
          id: 15,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1666,
                y: 0,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 1666,
                y: 562,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '7',
                x: 1666,
                y: 1124,
                width: 834,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-16.png',
          id: 16,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1666,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1666,
                y: 0,
                width: 834,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1666,
                y: 422,
                width: 834,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 0,
                y: 843,
                width: 833,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 0,
                y: 1264,
                width: 833,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '7',
                x: 1666,
                y: 843,
                width: 834,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '8',
                x: 1666,
                y: 1264,
                width: 834,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-17.png',
          id: 17,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1875,
                y: 0,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 0,
                y: 562,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 625,
                y: 562,
                width: 1250,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '7',
                x: 1875,
                y: 562,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '8',
                x: 0,
                y: 1124,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '9',
                x: 625,
                y: 1124,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '10',
                x: 1250,
                y: 1124,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '11',
                x: 1875,
                y: 1124,
                width: 625,
                height: 562,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-18.png',
          id: 18,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 843,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1250,
                y: 843,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-19.png',
          id: 19,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 2500,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 0,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 833,
                y: 843,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1666,
                y: 843,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-20.png',
          id: 20,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1500,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1500,
                y: 0,
                width: 1000,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1500,
                y: 843,
                width: 1000,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-21.png',
          id: 21,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 2500,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 0,
                y: 843,
                width: 2500,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-22.png',
          id: 22,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 1250,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-23.png',
          id: 23,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 1686
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 2500,
                height: 1686,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        }
      ],
      small: [
        {
          image: iconSmall,
          id: 100
        },
        {
          image: '/img/templates/template-sm-01.png',
          id: 24,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1875,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF',
                strokeWidth: 1
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-02.png',
          id: 25,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1875,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 0,
                y: 421,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '6',
                x: 625,
                y: 421,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '7',
                x: 1250,
                y: 421,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '8',
                x: 1875,
                y: 421,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-03.png',
          id: 26,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 1250,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1250,
                y: 421,
                width: 1250,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-04.png',
          id: 27,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 625,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 421,
                width: 625,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 625,
                y: 421,
                width: 625,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1250,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-05.png',
          id: 28,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 0,
                y: 421,
                width: 1250,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1250,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1875,
                y: 0,
                width: 625,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-06.png',
          id: 29,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 833,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 833,
                y: 0,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1667,
                y: 0,
                width: 834,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-07.png',
          id: 30,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 1875,
                y: 0,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1250,
                y: 421,
                width: 625,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '5',
                x: 1875,
                y: 421,
                width: 625,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-08.png',
          id: 31,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 1250,
                height: 421,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '3',
                x: 0,
                y: 421,
                width: 1250,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '4',
                x: 1250,
                y: 421,
                width: 1250,
                height: 422,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-09.png',
          id: 32,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1250,
                y: 0,
                width: 1250,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-10.png',
          id: 33,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 750,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 750,
                y: 0,
                width: 1750,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-11.png',
          id: 34,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 1750,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            },
            {
              bounds: {
                name: '2',
                x: 1750,
                y: 0,
                width: 750,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        },
        {
          image: '/img/templates/template-sm-12.png',
          id: 35,
          selected: true,
          chatBarText: 'Menu',
          size: {
            width: 2500,
            height: 843
          },
          areas: [
            {
              bounds: {
                name: '1',
                x: 0,
                y: 0,
                width: 2500,
                height: 843,
                stroke: '#FFFFFF'
              },
              action: { type: 'none' }
            }
          ]
        }
      ]
    }
    commit('GET_RICHMENUTEMPLATE', richMenu)
    return richMenu
  },
  getPresetMenu: async function ({ commit }) {
    var data = [
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1630496618934_1630496618707.jpg',
        content_json:
          '{"id":"1630496584766","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1630496595668","x":5,"y":4,"rotation":0,"width":1700,"height":1070,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Order Now","data":"Order Now"},"image":null},{"bounds":{"name":"1630496601507","x":10,"y":1110,"rotation":0,"width":1660,"height":560,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Delivery","data":"Delivery"},"image":null},{"bounds":{"name":"1630496607289","x":1780,"y":1035,"rotation":0,"width":665,"height":640,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Promotion","data":"Promotion"},"image":null},{"bounds":{"name":"1630496610998","x":1790,"y":555,"rotation":0,"width":685,"height":440,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Branches","data":"Branches"},"image":null},{"bounds":{"name":"1630496614162","x":1790,"y":5,"rotation":0,"width":690,"height":455,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Membership Card","data":"Membership Card"},"image":null}],"bgImage":{}}'
      },
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1630744940280_1630744938883.jpg',
        content_json:
          '{"id":"1630497201968","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1630497210356","x":105,"y":75,"rotation":0,"width":1300,"height":370,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ดูคอร์สทั้งหมด","data":"ดูคอร์สทั้งหมด"},"image":null},{"bounds":{"name":"1630497214121","x":95,"y":510,"rotation":0,"width":655,"height":610,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ประวัติคุณหมอ","data":"ประวัติคุณหมอ"},"image":null},{"bounds":{"name":"1630497218152","x":90,"y":1185,"rotation":0,"width":670,"height":435,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"จองคิว","data":"จองคิว"},"image":null},{"bounds":{"name":"1630497221486","x":810,"y":545,"rotation":0,"width":740,"height":700,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ปรึกษาคุณหมอ","data":"ปรึกษาคุณหมอ"},"image":null},{"bounds":{"name":"1630497224727","x":790,"y":1295,"rotation":0,"width":790,"height":315,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"โปรโมชั่น","data":"โปรโมชั่น"},"image":null},{"bounds":{"name":"1630497230898","x":1650,"y":975,"rotation":0,"width":780,"height":650,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"รับสิทธิ์ทดลองฟรี","data":"รับสิทธิ์ทดลองฟรี"},"image":null},{"bounds":{"name":"1630497305236","x":1635,"y":690,"rotation":0,"width":785,"height":250,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ดูรีวิว","data":"ดูรีวิว"},"image":null}],"bgImage":{}}'
      },
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1631003968091_1631003966832.jpg',
        content_json:
          '{"id":"1622171373917","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1622171388380","x":123,"y":63,"rotation":0,"width":894,"height":603,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Promotion","data":"Promotion"},"image":null},{"bounds":{"name":"1622171395823","x":205,"y":700,"rotation":0,"width":740,"height":485,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Review","data":"Review"},"image":null},{"bounds":{"name":"1622171401983","x":20,"y":1220,"rotation":0,"width":1109,"height":364,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Tracking No.","data":"Tracking No."},"image":null},{"bounds":{"name":"1622171410014","x":1056,"y":242,"rotation":0,"width":708,"height":587,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ราคา & รายละเอียด","data":"ราคา & รายละเอียด"},"image":null},{"bounds":{"name":"1622171424078","x":1892,"y":302,"rotation":0,"width":442,"height":432,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":""},"image":null},{"bounds":{"name":"1622171448586","x":1175,"y":880,"rotation":0,"width":690,"height":665,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ติดต่อแอดมิน","data":"ติดต่อแอดมิน"},"image":null},{"bounds":{"name":"1622171455389","x":1889,"y":755,"rotation":0,"width":464,"height":424,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":""},"image":null},{"bounds":{"name":"1622171465188","x":1905,"y":1205,"rotation":0,"width":437,"height":430,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":""},"image":null}],"bgImage":{}}'
      },
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1630655487092_1630655486260.jpg',
        content_json:
          '{"id":"1622107293920","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1622107379508","x":70,"y":235,"rotation":0,"width":1910,"height":340,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":""},"image":null},{"bounds":{"name":"1622107384381","x":110,"y":925,"rotation":0,"width":695,"height":700,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ติดต่อฝ่ายขาย","data":"ติดต่อฝ่ายขาย"},"image":null},{"bounds":{"name":"1622107390790","x":965,"y":785,"rotation":0,"width":694,"height":689,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ติดต่อแจ้งปัญหา","data":"ติดต่อแจ้งปัญหา"},"image":null},{"bounds":{"name":"1622107402134","x":1779,"y":614,"rotation":0,"width":655,"height":649,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ติดต่ออื่นๆ","data":"ติดต่ออื่นๆ"},"image":null}],"bgImage":{}}'
      },
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1631011061797_1631011061249.jpg',
        content_json:
          '{"id":"1630563919708","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1630563942083","x":0,"y":5,"rotation":0,"width":1345,"height":495,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ดูรีวิว","data":"pb=10|ดูรีวิว"},"image":null},{"bounds":{"name":"1630563951853","x":1385,"y":5,"rotation":0,"width":1105,"height":490,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"http://link.zwiz.ai/LineRichmenuStat?rm=10&rurl=https%3A%2F%2Fwww.google.com%2Fmaps%2Fplace%2FCentral%2BPlaza%2BPinklao%2F%4013.7780166%2C100.4742719%2C17z%2Fdata%3D!3m1!4b1!4m5!3m4!1s0x30e29986880a1a93%3A0x5dc66c10ffa1a8e5!8m2!3d13.7780166!4d100.4764606%3Fhl%3Den-TH"},"image":null},{"bounds":{"name":"1630563961944","x":15,"y":535,"rotation":0,"width":650,"height":580,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"สินค้าขายดี","data":"pb=10|สินค้าขายดี"},"image":null},{"bounds":{"name":"1630563966399","x":709,"y":545,"rotation":0,"width":1774,"height":584,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"สินค้าทั้งหมด","data":"pb=10|สินค้าทั้งหมด"},"image":null},{"bounds":{"name":"1630563974233","x":10,"y":1175,"rotation":0,"width":605,"height":495,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"http://link.zwiz.ai/LineRichmenuStat?rm=10&rurl=https%3A%2F%2Fm.me%2F361231620965547"},"image":null},{"bounds":{"name":"1630563981078","x":640,"y":1170,"rotation":0,"width":730,"height":510,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"ติดต่อแอดมิน","data":"pb=10|ติดต่อแอดมิน"},"image":null},{"bounds":{"name":"1630563986509","x":1395,"y":1180,"rotation":0,"width":539,"height":489,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"http://link.zwiz.ai/LineRichmenuStat?rm=10&rurl=https%3A%2F%2Finstagram.com%2Fzwiz_official%3Futm_medium%3Dcopy_link"},"image":null},{"bounds":{"name":"1630563995006","x":1950,"y":1179,"rotation":0,"width":534,"height":490,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"http://link.zwiz.ai/LineRichmenuStat?rm=10&rurl=https%3A%2F%2Fwww.facebook.com%2Fzwizai"},"image":null}],"bgImage":{}}'
      },
      {
        image_url:
          'https://s3.ap-southeast-1.amazonaws.com/zwizai-platform/platform/1633320517215_1633320518448.jpg',
        content_json:
          '{"id":"1622089351114","chatBarText":"Menu","selected":true,"size":{"width":2500,"height":1686},"areas":[{"bounds":{"name":"1622089393747","x":100,"y":87,"rotation":0,"width":1114,"height":425,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"tel:+6628215535"},"image":null},{"bounds":{"name":"1622089424542","x":1909,"y":620,"rotation":0,"width":559,"height":233,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"uri","uri":"http://link.zwiz.ai/LineRichmenuStat?rm=871&rurl=https%3A%2F%2Fwww.google.com%2Fmaps%2Fplace%2FCentral%2BPlaza%2BPinklao%2F%4013.7780166%2C100.4742719%2C17z%2Fdata%3D!3m1!4b1!4m5!3m4!1s0x30e29986880a1a93%3A0x5dc66c10ffa1a8e5!8m2!3d13.7780166!4d100.4764606%3Fhl%3Den-TH"},"image":null},{"bounds":{"name":"1622089431068","x":1685,"y":1085,"rotation":0,"width":783,"height":233,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Promotion","data":"pb=871|Promotion"},"image":null},{"bounds":{"name":"1622089445299","x":30,"y":775,"rotation":0,"width":520,"height":370,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","phone_number":"+6628215535","text":"Contact","data":"pb=871|Contact"},"image":null},{"bounds":{"name":"1622089459022","x":784,"y":1026,"rotation":0,"width":849,"height":592,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Booking","data":"pb=871|Booking"},"image":null},{"bounds":{"name":"1622089485277","x":1390,"y":95,"rotation":0,"width":990,"height":395,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","uri":"Room & Offers","text":"Room & Offers","data":"pb=871|Room & Offers"},"image":null},{"bounds":{"name":"1622089506080","x":49,"y":1185,"rotation":0,"width":685,"height":409,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Activities","data":"pb=871|Activities"},"image":null},{"bounds":{"name":"1622089522356","x":1805,"y":1394,"rotation":0,"width":654,"height":205,"stroke":"#FFFFFF","strokeWidth":1,"draggable":true,"scaleX":1,"scaleY":1},"action":{"type":"postback","text":"Review ","data":"pb=871|Review "},"image":null}],"bgImage":{}}'
      }
    ]

    commit('GET_PRESETMENU', data)
    return data
  },
  getLineRichMenu: async function ({ commit }) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.get('line_richmenu_by_account', {
        business_id
      })
      commit('SET_LINERICHMENU', response.data.data)
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  setTemplateSelect: async function ({ commit }, item) {
    try {
      commit('SET_TEMPLATESELECT', item)
      return item
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  setCheckClickTrial: async function ({ commit }, clickTrial) {
    commit('SET_CHECKCLICKTRIAL', clickTrial)
  },
  setImageSelect: async function ({ commit }, imageSelect) {
    commit('SET_IMAGESELECT', imageSelect)
  },
  setUploadSelectType: async function ({ commit }, uploadSelectType) {
    commit('SET_UPLOADSELECTTYPE', uploadSelectType)
  },
  setTypeEditNew: async function ({ commit }, uploadSelectType) {
    commit('SET_TYPEEDITNEW', uploadSelectType)
  },
  setIdTemplate: async function ({ commit }, payload) {
    commit('SET_IDTEMPLATE', payload)
  },
  setScaleBgImage: async function ({ commit }, payload) {
    commit('SET_SCALE', payload)
  },
  postTemplateSelect: async function ({ commit }, payload) {
    try {
      // console.log(payload);
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('create_line_richmenu', payload, {
        params: { business_id }
      })
      if (response) {
        commit('SET_IDTEMPLATE', response.data.line_richmenu_id)
        commit('SET_TEMPLATESELECT', payload)
        return response
      }
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  putTemplateSelect: async function ({ commit, state }, payload) {
    try {
      if (typeof payload[0] !== 'undefined') {
        payload = payload[0]
      } else {
        if (payload.connected_channel_id) {
          delete payload.connected_channel_id
        }
      }
      if (payload && payload.content_json) {
        try {
          let content_json
          if (typeof payload.content_json == String) {
            content_json = JSON.parse(payload.content_json)
          } else {
            content_json = payload.content_json
          }
          if (content_json.areas && content_json.areas.length > 0) {
            content_json.areas = content_json.areas.map((el) => {
              if (el.bounds) {
                let height = parseInt(el.bounds.height)
                let width = parseInt(el.bounds.width)
                let x = parseInt(el.bounds.x)
                let y = parseInt(el.bounds.y)

                //Prevent negative height
                if (height < 1) {
                  y = y + height
                  height = height * -1
                }

                //Prevent negative width
                if (width < 1) {
                  x = x + width
                  width = width * -1
                }

                el.bounds = {
                  ...el.bounds,
                  height,
                  width,
                  x,
                  y
                }
              }
              return el
            })
            payload.content_json = JSON.stringify(content_json)
          }
        } catch (error) {
          console.error(error)
        }
      }
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('update_line_richmenu', payload, {
        params: { line_richmenu_id: state.idTemplate, business_id }
      })
      commit('SET_TEMPLATESELECT', response.data.data[0])
      return response
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return { _isError: true, error: error.response ? error.response.data : error }
    }
  },
  deleteTemplate: async function ({ commit }, id) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.delete('delete_line_richmenu', {
        line_richmenu_id: id,
        business_id
      })
      commit('DELETE_RICHMENU', id)
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  startRichmenu: async function (_, payload) {
    // console.log(commit);
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put(
        'start_line_richmenu',
        {
          set_default_schedule: payload.set_default_schedule,
          set_default_schedule_setting: payload.set_default_schedule_setting
        },
        { params: { ...payload.data, business_id } }
      )
      response.status = true
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      } else if (error.response.status === 300) {
        return error.response.data.reason
      }
      return null
    }
  },
  stopRichmenu: async function (_, id) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('stop_line_richmenu', null, {
        params: { line_richmenu_id: id, business_id }
      })
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      if (error.response.status === 300) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  createLineRichmenuPackage: async function (_, payload) {
    var data = {
      amount: payload.amount,
      referenceNo: payload.referenceNo,
      gbpReferenceNo: payload.gbpReferenceNo
    }
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post(
        'create_line_richmenu_package',
        data,
        { params: { ...payload, business_id } }
      )
      if (response) {
        // console.log(response);
        // console.log(commit);
        // commit("SET_IDTEMPLATE", response.data.line_richmenu_id);
        // commit("SET_TEMPLATESELECT", payload);
        return response
      }
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  },
  lineRichmenuPackageByAccount: async function ({ commit }) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.get('line_richmenu_package_by_account', {
        business_id
      })
      commit('SET_PACKAGERICHMENU', response.data.data)
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return error
    }
  },
  setSelectGroupId: async function ({ commit }, groupId) {
    commit('SET_SELECT_GROUPID', groupId)
  },
  getLineRichMenuStat: async function (_, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.get('analytics/richmenu/report', {
        ...payload,
        business_id
      })
      return response
    } catch (error) {
      if (error.response.status === 400) {
        this.dispatch('login/logout')
      }
      return null
    }
  }
}
